module.exports = "<div *ngIf=\"display\" class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"alert alert-danger alert-dismissible fade in\" role=\"alert\" data-spy=\"affix\" data-offset-top=\"100\"> \r\n      <h4>{{errorTitle}}</h4>\r\n      <p>{{errorMessage}}</p>\r\n      <p> <button type=\"button\" class=\"btn btn-danger\" (click)=\"refreshPage()\">Refresh the page</button> </p>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/notify/notify.component.html
// module id = ../../../../../src/app/components/notify/notify.component.html
// module chunks = main